import { Coords } from 'src/app/swagger-api';
import MapSettings from '../../map.settings';

export class DistanceCalculator {
  /**
   * @description Returns the distance between two points in meter that calculated by its coords.
   *              Used: https://www.movable-type.co.uk/scripts/latlong.html
   * @param { Coords } coords1
   * @param { Coords } coords2
   * @returns { number }
   */
  public static getDistanceBetweenTwoMapPoints(coords1: Coords, coords2: Coords): number {
    const phi1: number = this.toRadians(coords1.lat);
    const phi2: number = this.toRadians(coords2.lat);
    const deltaPhi: number = this.toRadians(coords2.lat - coords1.lat);
    const deltaLambda: number = this.toRadians(coords2.lon - coords1.lon);

    const calculated: number =
      Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
      Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
    const angle: number = 2 * Math.atan2(Math.sqrt(calculated), Math.sqrt(1 - calculated));

    return MapSettings.GOOGLE_MAPS_EARTH_MEAN_RADIUS_IN_METER * angle;
  }

  /**
   * @description Convert degrees to Radians.
   * @param { number } x
   * @returns { number }
   */
  private static toRadians(x: number): number {
    return (x * Math.PI) / 180;
  }
}
